<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="inspectionReports/inspectorBacklogList">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="凭证号">
            <el-input v-model.trim="filter.voucherNo" clearable/>
          </vm-search>
          <vm-search label="报告编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column prop="no" align="center" label="报告编号">
        <template slot-scope="scope">
          <span v-if="scope.row.no==='test'">***</span>
          <span v-else>{{scope.row.no}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="voucherNo" width="110" align="center" label="凭证号"/>
      <el-table-column prop="createdTime" align="center" width="180px" label="报告创建时间"/>
      <!--      <el-table-column prop="barcode" align="center" width="180px" label="条码"/>-->
      <el-table-column prop="flowStatus" align="center" label="流程状态">
        <template slot-scope="scope">
          {{constant.flowStatus[scope.row.flowStatus]}}
        </template>
      </el-table-column>
      <el-table-column prop="preliminaryInvestigation" align="center" label="问题描述"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <preview ref="preview" @save-success="getList(-1)"/>
    <inspection-incoming-edit ref="editInspectionIncoming" @save-success="getList(-1)"/>
    <inspection-report-edit ref="editInspectionReport" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import constants from "@/util/constants";
  import Preview from "@/views/inspection/inspectionReport/Preview";
  import InspectionReportEdit from "@/views/inspection/inspectionReport/InspectionReportEdit";
  import InspectionIncomingEdit from "@/views/inspection/inspectionIncoming/InspectionIncomingEdit";

  export default {
    components: {InspectionReportEdit, InspectionIncomingEdit, Preview, VmTable, VmSearch},
    data() {
      return {
        constant,
        constants,
        reportStatus: constant.toSelect(constant.reportStatus, "addAll"),
        show: "",
        exportLoading: false,
        exportLoading1: false,
        submitLoading: false,
        filter: {
          filter: "",
          storageInspectionType: "",
          flowStatus: 5,
          voucherNo: "",
          no: "",
          materialNo: "",
          problemClassification: "",
          qualitativeClassification: "",
        },
        details: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleSearch() {
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      exportExcel1() {
        this.exportLoading1 = true;
        this.$http
          .exportFile("basic", "inspectionReports/exportInspection", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading1 = false;
          })
          .catch(() => {
            this.exportLoading1 = false;
          });
      },
      edit(row) {
        console.log(row);
        if (row.storageInspectionType === 30) {
          this.$refs.editInspectionIncoming.open(row.masterId);
        }else {
          this.$refs.editInspectionReport.open(row);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
